const CUSTOM_ASSETS_BASE = "assets/images/instructions/custom";

export const PAGE_IDS = [
 "m201",
 "m202",
 "m203",
 "m204",
 "m205",
 "m206",
];

export const MISSION_TWO_PAGE_COUNT = PAGE_IDS.length;

export const OVERLAY_SIZE_PRESETS = {
 sm: { overlayLeftPercent: 51, overlayTopPercent: 89.5 },
 md: { overlayLeftPercent: 53, overlayTopPercent: 89.5 },
 lg: { overlayLeftPercent: 57, overlayTopPercent: 89.5 },
};

// Overlay coordinates are defaults/fallbacks for the nav hint.
// When a page has a bubble, the instructions plugin anchors the nav hint to that bubble.
export const OVERLAY_BY_PAGE = {
 m201: { overlayLeftPercent: 61, overlayTopPercent: 89.5, showBackKey: false },
 m202: { overlayLeftPercent: 50, overlayTopPercent: 90.5 },
 m203: { overlayLeftPercent: 66.5, overlayTopPercent: 89.5, showBackKey: false },
 m204: { overlayLeftPercent: 51, overlayTopPercent: 89.5 },
 m205: { overlayLeftPercent: 61, overlayTopPercent: 89.5, showBackKey: false },
 m206: { overlayLeftPercent: 51, overlayTopPercent: 89.5 },
};

export const DEFAULT_PAGE_UI = {
 showPilot: false,
};

export const PAGE_UI_BY_PAGE = {
 m201: { showPilot: true },
};

export const BUBBLE_DEFAULT_LAYOUT = {
 wrapperLeftPercent: 32.5,
 wrapperBottomPercent: 8,
 minWidthPercent: 36,
 maxWidthPercent: 52,
 fontSizeVw: 0.85,
 padding: "0.9vw 1.2vw 2.4vw 1.2vw",
 tailBottomVw: -1.5,
 tailLeftVw: -1.5,
 tailWidthVw: 9.4,
 tailHeightVw: 2.5,
};

export const PILOT_LAYOUT_ADJUSTMENTS = {
 bubbleMaxWidthPercent: 38,
 overlayLeftOffsetPercent: -4,
};

export const FELLOW_EMOTION_SOURCES = {
 "hq-happy": `${CUSTOM_ASSETS_BASE}/hq-happy.svg`,
 "hq-impressed": `${CUSTOM_ASSETS_BASE}/hq-impressed.svg`,
 "hq-neutral": `${CUSTOM_ASSETS_BASE}/hq-neutral.svg`,
 "hq-speaking": `${CUSTOM_ASSETS_BASE}/hq-speaking.svg`,
};

export const MISSION_TWO_BACKGROUND_SRC = `${CUSTOM_ASSETS_BASE}/background.svg`;
export const MISSION_TWO_PILOT_SRC = `${CUSTOM_ASSETS_BASE}/driver.svg`;
